import { defineMessages } from 'react-intl';

const scope = 'app.components.TapToTip.Setup.TourPhotoShareSection';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Shared Photo Message'
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      "When a guest shares one of their tour photos, this is the wording that goes with it. Use '{company}' for your company name and '{guide}' for the guide who took the photo."
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save'
  },
  shareTitle: {
    id: `${scope}.shareTitle`,
    defaultMessage: 'Title'
  },
  shareText: {
    id: `${scope}.shareText`,
    defaultMessage: 'Message'
  },
  shareTitlePlaceholder: {
    id: `${scope}.shareTitlePlaceholder`,
    defaultMessage: 'Photos from your tour'
  },
  shareTextPlaceholder: {
    id: `${scope}.shareTextPlaceholder`,
    defaultMessage: "A photo from my tour with '{company}'. Take a look."
  },
  // The one thing operators will otherwise assume works and be disappointed by.
  instagramNote: {
    id: `${scope}.instagramNote`,
    defaultMessage:
      'Facebook, LinkedIn, WhatsApp and Messages show this wording. Instagram does not let any app set a caption, so photos shared there arrive without it.'
  },
  preview: {
    id: `${scope}.preview`,
    defaultMessage: 'Guests will see'
  },
  // Stands in for {guide} in the preview — the real name depends on who took
  // the photo, so the preview must not pretend to know it.
  sampleGuideName: {
    id: `${scope}.sampleGuideName`,
    defaultMessage: 'your guide'
  }
});
